import { create } from 'zustand';

type AlertOptions = {
  title: string;
  description?: string;
  onConfirm?: () => void | Promise<void>;
  confirmText?: string;
  type: 'info' | 'warning' | 'error' | 'success' | 'destructive';
};

export interface AlertState {
  options: AlertOptions | null;
  isOpen: boolean;
  openAlert: (options: AlertOptions) => void;
  closeAlert: () => void;
}

const useAlertStore = create<AlertState>(set => ({
  options: null,
  isOpen: false,

  openAlert: (options: AlertOptions) => set({ isOpen: true, options }),
  closeAlert: () => set({ isOpen: false }),
}));

export default useAlertStore;
